import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { machineOptionLabel } from '@/lib/machineLabel';
import { cn } from '@/lib/utils';

export interface MachineSelectOption {
  id: string;
  name: string;
  serialNumber?: string | null;
  venueName?: string | null;
}

export interface MachineSelectProps {
  value: string;
  onValueChange: (value: string) => void;
  machines: MachineSelectOption[];
  placeholder?: string;
  disabled?: boolean;
  id?: string;
  triggerClassName?: string;
  /** When true, user can clear selection (value ""). */
  allowEmpty?: boolean;
  emptyLabel?: string;
}

export function MachineSelect({
  value,
  onValueChange,
  machines,
  placeholder = 'Select machine',
  disabled,
  id,
  triggerClassName,
  allowEmpty = false,
  emptyLabel = 'All machines',
}: MachineSelectProps) {
  return (
    <Select
      value={value || (allowEmpty ? '__empty__' : undefined)}
      onValueChange={(next) => onValueChange(next === '__empty__' ? '' : next)}
      disabled={disabled}
    >
      <SelectTrigger id={id} className={cn(triggerClassName)}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {allowEmpty && (
          <SelectItem value="__empty__">{emptyLabel}</SelectItem>
        )}
        {machines.map((machine) => (
          <SelectItem key={machine.id} value={machine.id}>
            {machineOptionLabel(machine)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
